import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';
import App from './components/shared/App';
import './styles/library.css';

const root = ReactDOM.createRoot(document.querySelector('#root') as Element);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
